/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  useTheme,
  Divider,
} from '@mui/material';

const pgtResults = [
  {
    id: 'C-1',
    date: '04/13/2025',
    time: '12:00PM',
    grade: '4BC',
    specimen: 'Day 5',
    incubator: 'A',
    witness: 'Mike Deo',
    embryologist: 'Akshaya P',
    karyotype: '46, XX',
    result: 'Euploid',
    sexAtBirth: 'Female',
  },
  {
    id: 'C-2',
    date: '04/13/2025',
    time: '12:00PM',
    grade: '4AA',
    specimen: 'Day 5',
    incubator: 'B',
    witness: 'Mike Deo',
    embryologist: 'Akshaya P',
    karyotype: '47, XX, +10, +15, -11',
    result: 'Aneuploid',
    sexAtBirth: 'Female',
  },
  {
    id: 'C-3',
    date: '04/13/2025',
    time: '12:00PM',
    grade: '3AA',
    specimen: 'Day 6',
    incubator: 'A',
    witness: 'Mike Deo',
    embryologist: 'Akshaya P',
    karyotype: 'Inconclusive',
    result: 'No Result',
    sexAtBirth: '-',
  },
  {
    id: 'C-4',
    date: '04/13/2025',
    time: '12:00PM',
    grade: '3AB',
    specimen: 'Day 6',
    incubator: 'C',
    witness: 'Mike Deo',
    embryologist: 'Akshaya P',
    karyotype: '46, XX',
    result: 'Euploid',
    sexAtBirth: 'Male',
  },
  {
    id: 'C-5',
    date: '04/13/2025',
    time: '12:00PM',
    grade: '3AB',
    specimen: 'Day 7',
    incubator: 'B',
    witness: 'Mike Deo',
    embryologist: 'Akshaya P',
    karyotype: '46, XX/47, XX, +1',
    result: 'Mosaic +1',
    sexAtBirth: 'Female',
  },
];

export default function PgtResult() {
  const theme = useTheme();

  return (
    <Card sx={{ p: 1, boxShadow: 'none', border: 'none' }}>
      
      <Divider sx={{ mb: 2, borderColor: theme.palette.divider }} />
      <CardContent sx={{ p: 0 }}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            boxShadow: 'none',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            overflowX: 'auto',
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  'ID',
                  'Biopsy Date & Time',
                  'Embryo Grade',
                  'Specimen',
                  'Incubator',
                  'Witness',
                  'Embryologist',
                  'Karyotype',
                  'Result',
                  'Sex Assigned At Birth',
                ].map((header, idx) => (
                  <TableCell
                    key={idx}
                    sx={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: 600,
                      fontSize: '0.88rem',
                      color: '#333',
                      whiteSpace: 'nowrap',
                      padding: '10px 16px',
                      borderBottom: '1px solid #ccc',
                      lineHeight: 2.5,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {pgtResults.map((item, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: theme.palette.action.selected,
                      transform: 'scale(1.005)',
                      boxShadow: `0 2px 4px ${theme.palette.action.hover}`,
                    },
                    '& td': {
                      fontSize: '0.85rem',
                      padding: '10px 16px',
                      lineHeight: 2.5,
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    },
                  }}
                >
                  <TableCell>{item.id}</TableCell>
                  <TableCell>{`${item.date} | ${item.time}`}</TableCell>
                  <TableCell>{item.grade}</TableCell>
                  <TableCell>{item.specimen}</TableCell>
                  <TableCell>{item.incubator}</TableCell>
                  <TableCell>{item.witness}</TableCell>
                  <TableCell>{item.embryologist}</TableCell>
                  <TableCell>{item.karyotype}</TableCell>
                  <TableCell>{item.result}</TableCell>
                  <TableCell>{item.sexAtBirth}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button variant="contained" color="secondary" sx={{ px: 4, borderRadius: 3 }}>
            Generate Report
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
